<template>
  <div>
    <div class="f-search-block">
      <el-form
        ref="formInline"
        :inline="true"
        :model="formInline"
      >
        <el-form-item
          label="表单名称"
          prop="template_name"
        >
          <el-input
            v-model="formInline.template_name"
            placeholder="请输入活动名称"
          />
        </el-form-item>
        <el-form-item
          label="创建日期"
          prop="dateRange"
        >
          <el-date-picker
            v-model="formInline.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >
          查询
        </el-button>
        <!-- <el-form-item label="活动状态" prop="status">
          <el-select v-model="formInline.status" placeholder="请选择活动状态">
            <el-option label="未开始" value="0"></el-option>
            <el-option label="进行中" value="1"></el-option>
            <el-option label="已结束" value="2"></el-option>
            <el-option label="已删除" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="启动状态" prop="startStatus">
          <el-select v-model="formInline.startStatus" placeholder="请选择启动状态">
            <el-option label="全部" value="0"></el-option>
            <el-option label="已启用" value="1"></el-option>
            <el-option label="已关闭" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-row>
          <el-button @click="resetForm('formInline')">重置</el-button>
        </el-row> -->
      </el-form>
    </div>
    <div class="f-table-block">
      <el-container>
        <el-row>
          <el-button
            class="mb10"
            type="primary"
            @click="handleEdit(0)"
          >
            创建表单
          </el-button>
        </el-row>
      </el-container>

      <el-container>
        <el-table
          :data="shopList"
          style="width: 100%"
        >
          <el-table-column
            prop="template_name"
            label="表单名称"
          />
          <el-table-column
            prop="created_at"
            label="创建时间"
          />

          <el-table-column
            label="操作"
            width="300"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleEdit(scope.row.template_id)"
              >
                编辑
              </el-button>
              <el-button
                type="text"
                @click="handleCopy(scope.row)"
              >
                创建副本
              </el-button>
              <el-button
                type="text"
                @click="handleChangeStatus(scope.row, 3)"
              >
                删除
              </el-button>
              <!-- <el-tooltip
                v-if="scope.row.status !== 1"
                effect="dark"
                content="启用"
                placement="top"
              >
                <el-button
                  icon="el-icon-circle-check"
                  circle
                  type="success"
                  @click="handleChangeStatus(scope.row, 1)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.status === 1"
                effect="dark"
                content="关闭"
                placement="top"
              >
                <el-button
                  icon="el-icon-circle-close"
                  circle
                  type="danger"
                  @click="handleChangeStatus(scope.row, 2)"
                ></el-button>
              </el-tooltip> -->
              <!-- <el-tooltip v-if="scope.row.status !== 0" effect="dark" content="查看" placement="top">
                <el-button
                  icon="el-icon-search"
                  @click="showCode(scope.row.codeSrc)"
                  circle
                ></el-button>
              </el-tooltip> -->
              <!-- <el-tooltip
                v-if="scope.row.status === 0"
                effect="dark"
                content="编辑"
                placement="top"
              >
                <el-button
                  icon="el-icon-edit"
                  circle
                  @click="handleEdit(scope.row.template_id)"
                ></el-button>
              </el-tooltip> -->
              <!-- <el-tooltip effect="dark" content="复制" placement="top">
                <el-button
                  icon="el-icon-document-copy"
                  circle
                  @click="handleCopy(scope.row)"
                ></el-button>
              </el-tooltip> -->
              <!-- <el-tooltip effect="dark" content="删除" placement="top">
                <el-button
                  icon="el-icon-delete"
                  circle
                  type="danger"
                  @click="handleChangeStatus(scope.row, 3)"
                ></el-button>
              </el-tooltip> -->
            </template>
          </el-table-column>
          <!-- <el-table-column prop="template_id" label="表单id"> </el-table-column>

          <el-table-column prop="statusSwitch" label="状态" min-width="90">
            <template slot-scope="scope">
              <el-tag :type="scope.row.statusSwitch">{{ scope.row.statusSwitchText }}</el-tag>
            </template>
          </el-table-column> -->
        </el-table>
      </el-container>

      <el-pagination
        class="table-pagination"
        :current-page="formInline.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formInline.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total_count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
      <el-dialog
        :visible.sync="dialogVisible"
        width="40%"
      >
        <el-row
          type="flex"
          justify="end"
        >
          <el-col :span="24">
            <div class="tips">
              查看/预览表单
            </div>
          </el-col>
        </el-row>

        <el-row
          type="flex"
          justify="center"
        >
          <img
            :src="codeSrc"
            class="code"
          >
        </el-row>
        <el-row
          type="flex"
          justify="center"
        >
          <el-col :span="24">
            <div class="tips">
              手机扫描查看/预览表单
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'Management',

  data () {
    return {
      formInline: {
        template_name: '',
        status: null,
        template_id: '',
        page: 1,
        dateRange: null,
        page_size: 20
      },
      total_count: 0,
      shopList: [],
      dialogVisible: false,
      codeSrc: '',
      popupText: {
        0: {
          title: '开启表单',
          content: '表单开启后将无法再次编辑。确定要开启表单吗？'
        },
        1: {
          title: '开启表单',
          content: '确定要开启表单吗？'
        },
        2: {
          title: '关闭表单',
          content: '表单关闭后用户将无法提交表单。确定要关闭表单吗？'
        },
        3: {
          title: '删除表单',
          content: '确定要删除表单吗？'
        }
      }
    }
  },
  mounted () {
    this.getList()
  },
  created () {},
  methods: {
    async getList () {
      if (this.formInline.dateRange) {
        this.formInline.start_time = moment(this.formInline.dateRange[0]).format('YYYY-MM-DD')
        this.formInline.end_time = moment(this.formInline.dateRange[1]).format('YYYY-MM-DD')
      } else {
        this.formInline.start_time = null
        this.formInline.end_time = null
      }
      const data = await this.$api.formActivity.getFormsTemplateList(this.formInline)
      if (data) {
        this.setStatus(data.list)
        this.shopList = data.list
        this.total_count = data.total_count
      }
    },
    setStatus (shopList) {
      shopList = shopList.map((v) => {
        if (v.status === 0) {
          v.statusSwitch = ''
          v.statusSwitchText = '未启用'
        } else if (v.status === 1) {
          v.statusSwitch = 'success'
          v.statusSwitchText = '已启用'
        } else if (v.status === 2) {
          v.statusSwitch = 'info'
          v.statusSwitchText = '已关闭'
        }
        return { ...v }
      })
    },
    onSubmit () {
      this.formInline.page = 1
      this.getList()
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.onSubmit()
    },
    // 列表分页
    handleSizeChange (val) {
      this.formInline.page = 1
      this.formInline.page_size = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.formInline.page = val
      this.getList()
    },
    showCode (val) {
      this.codeSrc = val
      this.dialogVisible = true
    },
    // 编辑
    handleEdit (template_id) {
      this.$router.push({ path: '/setting/formWeappTmp?template_id=' + template_id })
    },
    // 状态变更
    handleChangeStatus (row, status) {
      // 对应弹窗文字
      let statusText = status === 1 ? (row.status === 0 ? 0 : 1) : status
      this.$confirm(this.popupText[statusText].content, this.popupText[statusText].title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const data = await this.$api.formActivity.changeFormsTemplateStatus({
          template_id: row.template_id,
          status // 启用 1，关闭 2，删除 3
        })
        if (data && data.status) {
          this.$message.success('操作成功')
          this.onSubmit()
        } else {
          return this.$message.error('操作失败')
        }
      })
    },
    // 复制
    async handleCopy (row) {
      const data = await this.$api.formActivity.copyFormsTemplate({
        template_id: row.template_id
      })
      if (data) {
        this.$message.success('复制成功')
        this.onSubmit()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  text-align: center;
  font-size: 20px;
  margin: 15px;
}
</style>
